import { AlertCircle } from 'lucide-react';
import { cn } from '~/shadcn/lib/utils';

function CalculationRow({ label, value, highlightError = false }) {
    return (
        <div className="flex justify-between items-center py-1">
            <span className="text-xs text-gray-700">{label}</span>
            <span className={cn('text-sm text-gray-800', highlightError && 'text-red-600')}>{value}</span>
        </div>
    );
}

function Step1_Calculations({ palletData, formData }) {
    const { totalUnits } = palletData;
    const totalUnitsPreppedIntoRPCs = (Number(formData.numRPCs) || 0) * (Number(formData.unitsPerRPC) || 0);
    const totalUnitsPrepped = totalUnitsPreppedIntoRPCs + (Number(formData.looseUnits) || 0);
    const totalUnitsWithScrap = totalUnitsPrepped + (Number(formData.scrapUnits) || 0);
    const remainingUnits = totalUnits - totalUnitsWithScrap;

    return (
        <div className="px-3 py-2  bg-gray-50 rounded-lg">
            <CalculationRow
                label="Total units prepped into RPCs:"
                value={totalUnitsPreppedIntoRPCs}
                highlightError={totalUnitsPreppedIntoRPCs <= 0}
            />
            <CalculationRow label="Total units prepped (RPCs*units + loose):" value={totalUnitsPrepped} />
            <CalculationRow
                label="Total units (RPCs + loose + scrap):"
                value={totalUnitsWithScrap}
                highlightError={totalUnitsWithScrap > totalUnits}
            />
            <CalculationRow label="Remaining units:" value={remainingUnits} highlightError={remainingUnits < 0} />

            {remainingUnits < 0 && (
                <div className="mt-1">
                    <div className="flex items-center text-red-600 text-xs">
                        <AlertCircle className="h-4 w-4 mr-2" />
                        <span>Number of units remaining cannot be negative</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Step1_Calculations;
